import { render, staticRenderFns } from "./ImgCommentInput.vue?vue&type=template&id=32abef1f&scoped=true&lang=pug"
import script from "./ImgCommentInput.vue?vue&type=script&lang=js"
export * from "./ImgCommentInput.vue?vue&type=script&lang=js"
import style0 from "./ImgCommentInput.vue?vue&type=style&index=0&id=32abef1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32abef1f",
  null
  
)

export default component.exports